/* ============================================================
   HOME · CYCLES SHOWCASE PREMIUM
   - Tab TODOS: vitrina curada (grid dedicado, máx 5 cards) + CTAs por objetivo.
   - Tabs por objetivo: grid principal, 1 card por marca + botón a colección.
   - Stagger reindexado al cambiar de tab. Ripple en CTAs. Editor-aware.
   - Respeta prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(root) {
    if (!root || root.__hcsInit) return;
    root.__hcsInit = true;

    var enableAnim = !prefersReduced && root.getAttribute('data-hcs-anim') === 'true';
    if (enableAnim) root.classList.add('hcs--animate');

    var grid = root.querySelector('[data-hcs-grid]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-hcs-card]')) : [];
    var todosGrid = root.querySelector('[data-hcs-todos-grid]');
    var todosCards = todosGrid ? Array.prototype.slice.call(todosGrid.querySelectorAll('[data-hcs-card]')) : [];
    var objActions = root.querySelector('[data-hcs-obj-actions]');
    var buttons = objActions ? Array.prototype.slice.call(objActions.querySelectorAll('.hcs__obj-btn')) : [];
    var todosActions = root.querySelector('[data-hcs-todos-actions]');
    var emptyMsg = root.querySelector('[data-hcs-empty]');

    function replayEnter(card) {
      if (!enableAnim) return;
      card.classList.remove('hcs-card--enter');
      void card.offsetWidth;
      card.classList.add('hcs-card--enter');
    }

    function showTodos() {
      cards.forEach(function (c) { c.hidden = true; });
      if (todosGrid) todosGrid.hidden = false;
      var idx = 0;
      todosCards.forEach(function (c) {
        c.hidden = false;
        c.style.setProperty('--i', idx);
        idx++;
        c.classList.add('is-in');
        replayEnter(c);
      });
      if (todosActions) todosActions.hidden = false;
      if (objActions) objActions.hidden = true;
      if (emptyMsg) emptyMsg.hidden = true;
    }

    function showFilter(filter) {
      if (todosGrid) todosGrid.hidden = true;
      if (todosActions) todosActions.hidden = true;
      if (objActions) objActions.hidden = false;

      var seenBrand = {};
      var visible = 0;
      var idx = 0;
      cards.forEach(function (card) {
        var obj = card.getAttribute('data-objetivo') || '';
        var brand = card.getAttribute('data-brand') || '';
        var show = false;
        if (obj === filter) {
          show = !seenBrand[brand];
          seenBrand[brand] = true;
        }
        card.hidden = !show;
        if (show) {
          card.style.setProperty('--i', idx);
          idx++;
          visible++;
          card.classList.add('is-in');
          replayEnter(card);
        }
      });
      buttons.forEach(function (b) {
        b.hidden = b.getAttribute('data-obj-btn') !== filter;
      });
      if (emptyMsg) emptyMsg.hidden = visible !== 0;
    }

    function applyFilter(filter) {
      if (filter === 'all') { showTodos(); } else { showFilter(filter); }
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hcs-tabs] .hcs__tab'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        applyFilter(tab.getAttribute('data-filter') || 'all');
      });
    });

    /* ---------- RIPPLE ---------- */
    function attachRipple(el) {
      el.addEventListener('click', function (e) {
        if (prefersReduced) return;
        var rect = el.getBoundingClientRect();
        var d = Math.max(rect.width, rect.height);
        var circle = document.createElement('span');
        circle.className = 'hcs-ripple';
        circle.style.width = d + 'px';
        circle.style.height = d + 'px';
        circle.style.left = (e.clientX - rect.left - d / 2) + 'px';
        circle.style.top = (e.clientY - rect.top - d / 2) + 'px';
        el.appendChild(circle);
        setTimeout(function () { if (circle.parentNode) circle.parentNode.removeChild(circle); }, 600);
      });
    }
    root.querySelectorAll('[data-hcs-ripple], .hcs__obj-btn').forEach(attachRipple);

    /* ---------- ENTRADA STAGGER (estado inicial = TODOS) ---------- */
    if (enableAnim && 'IntersectionObserver' in window) {
      var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-hcs-reveal]'));
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      todosCards.forEach(function (c) { io.observe(c); });
      root.__hcsIO = io;
    } else {
      root.querySelectorAll('[data-hcs-reveal], [data-hcs-todos-grid] [data-hcs-card]').forEach(function (el) {
        el.classList.add('is-in');
      });
    }
  }

  function destroySection(root) {
    if (!root) return;
    if (root.__hcsIO) { root.__hcsIO.disconnect(); root.__hcsIO = null; }
    root.__hcsInit = false;
  }

  function initAll() { document.querySelectorAll('[data-hcs]').forEach(initSection); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-hcs]');
    if (root) initSection(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-hcs]');
    if (root) destroySection(root);
  });
})();
